export default "__VITE_ASSET__Caj2l4dF__"